/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_LocaleInputs */

const he_profile_locale = /** @type {(inputs: Profile_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שפה`)
};

const en_profile_locale = /** @type {(inputs: Profile_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Profile_LocaleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_locale = /** @type {((inputs?: Profile_LocaleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_LocaleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_locale(inputs)
	return en_profile_locale(inputs)
});